import { HttpInterceptorFn } from '@angular/common/http';
import { LocalStorageService } from '../core/services/local-storage.service';
import { inject } from '@angular/core';

/**
 * Appends isWhiteLabel=true if the flag is set in storage
 * and the param is not already there.
 */
export const WhiteLabelInterceptor: HttpInterceptorFn = (req, next) => {
  const localStorageService = inject(LocalStorageService);

  const isWhiteLabel = localStorageService.get('isWhiteLabel') === 'true';
  if (!isWhiteLabel) return next(req);
  if (req.params.has('isWhiteLabel')) return next(req);
  return next(req.clone({ setParams: { isWhiteLabel: 'true' } }));
};
